(function () {
  var overlay = document.querySelector('[data-upsell-overlay]');
  if (!overlay) return;

  var acceptBtn = overlay.querySelector('[data-upsell-accept]');
  var declineBtns = overlay.querySelectorAll('[data-upsell-decline]');
  var extraVariantId = acceptBtn ? acceptBtn.getAttribute('data-variant-id') : null;
  var pending = null;
  var SEEN_KEY = 'sneakyUpsellSeen';

  function hasSeenUpsell() {
    try {
      return window.sessionStorage.getItem(SEEN_KEY) === '1';
    } catch (err) {
      return false;
    }
  }

  function markUpsellSeen() {
    try {
      window.sessionStorage.setItem(SEEN_KEY, '1');
    } catch (err) {
      /* storage unavailable (e.g. private mode) — safe to ignore */
    }
  }

  function openUpsell(action) {
    pending = action;
    overlay.hidden = false;
  }

  function closeUpsell() {
    overlay.hidden = true;
    markUpsellSeen();
  }

  function proceedWithOriginal() {
    if (!pending) return;
    if (pending.type === 'link') {
      window.location.href = pending.href;
    } else if (pending.type === 'form') {
      pending.form.submit();
    }
    pending = null;
  }

  document.addEventListener('click', function (e) {
    if (hasSeenUpsell()) return;
    var link = e.target.closest('a[href^="/cart/"]');
    if (link && /^\/cart\/\d+:/.test(link.getAttribute('href'))) {
      e.preventDefault();
      openUpsell({ type: 'link', href: link.getAttribute('href') });
    }
  });

  document.addEventListener('submit', function (e) {
    if (hasSeenUpsell()) return;
    var form = e.target;
    if (form.matches && form.matches('form[action*="/cart/add"]')) {
      e.preventDefault();
      openUpsell({ type: 'form', form: form });
    }
  });

  if (acceptBtn) {
    acceptBtn.addEventListener('click', function () {
      if (!pending || !extraVariantId) {
        closeUpsell();
        return;
      }
      if (pending.type === 'link') {
        var href = pending.href;
        var qIndex = href.indexOf('?');
        var base = qIndex === -1 ? href : href.substring(0, qIndex);
        var query = qIndex === -1 ? '' : href.substring(qIndex);
        window.location.href = base + ',' + extraVariantId + ':1' + query;
      } else if (pending.type === 'form') {
        var idInput = pending.form.querySelector('[name="id"]');
        var qtyInput = pending.form.querySelector('[name="quantity"]');
        var id = idInput ? idInput.value : null;
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        if (id) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [
                { id: id, quantity: qty },
                { id: extraVariantId, quantity: 1 }
              ]
            })
          })
            .then(function () { window.location.href = '/cart'; })
            .catch(function () { pending.form.submit(); });
        } else {
          pending.form.submit();
        }
      }
      pending = null;
      closeUpsell();
    });
  }

  declineBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      proceedWithOriginal();
      closeUpsell();
    });
  });

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) {
      proceedWithOriginal();
      closeUpsell();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) {
      proceedWithOriginal();
      closeUpsell();
    }
  });
})();
